import { render, staticRenderFns } from "./listaDeUsuariosParaBloquearLiberar.vue?vue&type=template&id=17fb106a"
import script from "./listaDeUsuariosParaBloquearLiberar.vue?vue&type=script&lang=js"
export * from "./listaDeUsuariosParaBloquearLiberar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports